// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3xh5J","alert":"SettungsInbox_alert__195or"};